import { render, staticRenderFns } from "./ZasadySpracovania.vue?vue&type=template&id=49583938"
import script from "./ZasadySpracovania.vue?vue&type=script&lang=js"
export * from "./ZasadySpracovania.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports